import React, { useState, useEffect } from 'react';
import BrandIcon from './BrandIcon.js';
import { getImageUrl } from '../SafeImage';

/**
 * Table image thumbnail specifically for Brands.
 * Uses the BrandIcon as the fallback when no brand logo exists.
 * Usage: <BrandTableImage src={record.imageUrl} alt="brand" />
 */
const BrandTableImage = ({ src, alt = '', size = 48, radius = 8 }) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setHasError(false);
    }, [src]);

    const finalSrc = getImageUrl(src);

    if (!finalSrc || hasError) {
        return (
            <div
                style={{
                    width: size,
                    height: size,
                    minWidth: size,
                    borderRadius: radius,
                    background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
                    border: '1px solid #c7d2fe',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.04)'
                }}
            >
                <BrandIcon size={Math.round(size * 0.65)} />
            </div>
        );
    }

    return (
        <img
            src={finalSrc}
            alt={alt}
            style={{
                width: size,
                height: size,
                minWidth: size,
                borderRadius: radius,
                border: '1px solid #e2e8f0',
                display: 'block',
                objectFit: 'cover'
            }}
            onError={() => setHasError(true)}
        />
    );
};

export default BrandTableImage;
